import licence from '../../assets/images/nz_licence-1.png';
import certificate from '../../assets/images/certificate.png';
import buynz from '../../assets/images/BuyNZMade_Logo_Black_Triangle.svg';
import gmp from '../../assets/images/gmp-1.png';
import haccp from '../../assets/images/haccp.png';

function Supplier() {
  return (
    <div className="supplier__container">
      <div className="supplier__box column">
        <div className="supplier-title">
          <h1 className="supplier__title-text">믿을 수 있는 생산처</h1>
        </div>
        <div className="supplier__row row">
          <div className="supplier__content">
            <img src={licence} alt="Nes Zealand licence" />
          </div>
          <div className="supplier__content">
            <img src={certificate} alt="Certificate of Recognition" />
          </div>
          <div className="supplier__content column">
            <a
              className="column"
              href="https://buynz.org.nz/Lifespan-NZ-Limited/7331-b329b4aa-903b-4cf5-b6fc-e811088f2f42-s1806820/"
              target="_blank"
              rel="noreferrer"
            >
              <img
                src={buynz}
                className="smaller_image"
                alt="Buy NZ Made Black logo"
              />
              <p>Licence Number</p>
              <p>806820</p>
            </a>
          </div>
          <div className="supplier__content">
            <img src={gmp} alt="Manufactured at a licensed GMP site" />
          </div>
          <div className="supplier__content">
            <img src={haccp} alt="HACCP Certified logo" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Supplier;
